import type { PatentTransferExtend } from '../types';
import type { ApiGetPatentBasicResponse } from '@/infrastructure/api-functions/core-search-api/get-patent-basic-api';

export interface GetPatentTransferDTO {
    getPatentTransfer(input: ApiGetPatentBasicResponse['TRANSFER']): PatentTransferExtend;
}

export const GetPatentTransferDTO = Symbol.for('GetPatentTransferDTO');
